import React from "react";
import { BasicChequeredBoard, BasicChequeredBoardProps } from "../../components/BasicChequeredBoard/BasicChequeredBoard";
import { FaqAccordionGroupProps } from "../../components/FaqAccordionGroup/FaqAccordionGroup";
import { Paragraph, ParagraphProps } from "../../components/Paragraph";
import { SeoHeaderProps } from "../../components/SeoHeader";
import { ServiceCataloguePageWrapper } from "../../components/ServiceCataloguePageWrapper";

export interface OutagesAndFaultsProps {
  seo?: SeoHeaderProps;
  pageTitle: string;
  paragraphs?: ParagraphProps[];
  chequeredBoard?: BasicChequeredBoardProps;
  faqs?: FaqAccordionGroupProps;
}

export const OutagesAndFaultsPage: React.FC<OutagesAndFaultsProps> = ({ seo, pageTitle, paragraphs, chequeredBoard, faqs }) => {
  return (
    <ServiceCataloguePageWrapper seo={seo} title={pageTitle} faqs={faqs}>
      {paragraphs && paragraphs[0] && <Paragraph {...paragraphs[0]} />}
      {chequeredBoard && <BasicChequeredBoard {...chequeredBoard} />}
    </ServiceCataloguePageWrapper>
  );
};
